import { createContext } from 'react'
import { apiSlice, postTracks, replaceTrack } from '../api/api'

const context = {
  files: {},
  cancelControllers: {},
  uploadTracks: function (dispatch, files) {
    files.forEach((file) => {
      const id = Date.now() + Math.floor(Math.random() * 10000)
      const formData = new FormData()
      formData.append('file', file)

      const [promise, cancel] = postTracks(formData, (progressEvent) => {
        if (progressEvent?.loaded) {
          const progress = Math.round(
            (100 * progressEvent.loaded) / progressEvent.total,
          )
          this.files = {
            ...this.files,
            [id]: {
              type: 'new',
              key: id,
              name: file?.name,
              status: 'uploading',
              progress,
            },
          }
        }
      })

      this.cancelControllers = {
        ...this.cancelControllers,
        [id]: cancel,
      }
      promise
        .then((res) => {
          this.files = {
            ...this.files,
            [id]: {
              key: id,
              name: file?.name,
              progress: 100,
              id: res?.data?.id,
              status: 'complete',
            },
          }

          dispatch(
            apiSlice.util.invalidateTags([{ type: 'Tracks', id: 'LIST' }]),
          )
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  replaceTrack: function ({ track, file, dispatch }) {
    const formData = new FormData()
    formData.append('file', file)
    const { url, id } = track

    const [promise, cancel] = replaceTrack(id, formData, (progressEvent) => {
      if (progressEvent?.loaded) {
        const progress = Math.round(
          (100 * progressEvent.loaded) / progressEvent.total,
        )
        this.files = {
          ...this.files,
          [id]: {
            type: 'replace',
            key: id,
            name: file?.name,
            status: 'uploading',
            progress,
          },
        }
      }
    })

    this.cancelControllers = {
      ...this.cancelControllers,
      [id]: cancel,
    }
    promise
      .then((res) => {
        this.files = {
          ...this.files,
          [id]: {
            key: id,
            name: file?.name,
            progress: 100,
            id: res?.data?.id,
            status: 'complete',
          },
        }

        dispatch(apiSlice.util.invalidateTags([{ type: 'Tracks', id: 'LIST' }]))
        dispatch(
          apiSlice.util.invalidateTags([
            { type: 'Track-Waveform', id: 'LIST' },
          ]),
        )
      })
      .catch((err) => {
        console.log(err)
      })
  },
  cancelUpload: function (file) {
    this.cancelControllers?.[file?.key]?.abort()
    delete this.files[file?.key]
  },
}

const UploadContext = createContext(context)

const UploadContextProvider = ({ children }) => (
  <UploadContext.Provider value={context}>{children}</UploadContext.Provider>
)

export { UploadContext, UploadContextProvider }
